import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../';
import { HttpClientService } from '../../../shared';
import { CookieManagerService ,ErrorManagerService} from '../../../shared/';
import { CookieNames, BasicRoutes, ApiEndpoints } from '../../constant';

@Component({
  selector: 'app-report-summary',
  templateUrl: '../views/report-summary.component.html',
  styleUrls: ['../../../css/report-summary.component.css','../../../css/paper-sets.component.css', ]
})

export class ReportSummaryComponent implements OnInit {

  paperReviewUrl:string = BasicRoutes.clientReview;
  partid : string;
  paperid : string;
  subjects : Object;

  constructor(private route: ActivatedRoute,
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private router: Router) { }

  ngOnInit() {
    this.paperid = this.cookieManagerService.getCookie(CookieNames.paperId, false).toString();
    this.route.params.forEach((params: Params) => {
        this.partid = params['partid'];
    });
    this.paperid = this.cookieManagerService.getCookie(CookieNames.paperId, false).toString();
    this.getSubjects();
    window.scrollTo(0, 0);
  }
  
  getSubjects(){
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getSubjects, {
      [ApiEndpoints.partid] : this.partid
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      if(response){
        this.subjects = response;
      }
    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }

  paperSetRouter(sub){
    this.router.navigate(['/home/reports/papers/'+ this.partid +'/summary/review/' + sub.subjectId+ "/" + sub.subject]);
  }

  public subCatagoris : Array<Object>;
  
  addSubjects(subs){
    this.cookieManagerService.setCookie(CookieNames.subjects, JSON.stringify(subs), false, 1);
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/components/report-summary.component.ts